import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { NostrProvider } from "nostr-react";
import {
  generatePrivateKey,
  getEventHash,
  getPublicKey,
  nip19,
  signEvent,
} from "nostr-tools";

const relayUrls = [
  "wss://nostr-pub.wellorder.net",
  "wss://relay.nostr.ch",
  "wss://nostr.bitcoiner.social",
];

const signMessage = async (msg) => {
  if (store.secretKeyMode === "d") {
    return await window.nostr.signEvent(msg);
  }
  let secretKey = ""; // in hex
  switch (store.secretKeyMode) {
    case "a":
      secretKey = generatePrivateKey();
      break;
    case "b":
      if (store.secretKey === "" || store.secretKey === null) {
        store.secretKey = nip19.nsecEncode(generatePrivateKey());
        window.localStorage.setItem("sk", store.secretKey);
        render();
      }
      // Pass through
    case "c":
      try {
        const rawSecretKey = nip19.decode(store.secretKey);
        if (rawSecretKey.type !== 'nsec') {
          window.alert("秘密鍵がおかしいみたい(ページ下部から設定できます)");
          return;
        }
        secretKey = rawSecretKey.data;
      } catch (e) {
        window.alert("秘密鍵がおかしいみたい(ページ下部から設定できます)");
        return;
      }
      break;
  }
  msg.pubkey = getPublicKey(secretKey);
  msg.id = getEventHash(msg);
  msg.sig = signEvent(msg, secretKey);
  return msg;
};

const updateSecretKeyMode = (m) => {
  store.secretKeyMode = m;
  window.localStorage.setItem("m", m);
  render();
};

const updateSecretKey = (sk) => {
  store.secretKey = sk;
  window.localStorage.setItem("sk", sk);
  render();
};

const store = {
  homepage: "note1x023n50phn3nc52y68s9992gndrkhrmdfaw6t293gvvju0h4jtfq7x3vlk",
  secretKeyMode: window.localStorage.getItem("m") || "b",
  secretKey: window.localStorage.getItem("sk"),
  signMessage,
  updateSecretKeyMode,
  updateSecretKey,
};

function render() {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <NostrProvider relayUrls={relayUrls} debug={true}>
        <App store={store} />
      </NostrProvider>
    </React.StrictMode>
  );
};
render();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
